import React from 'react';
import { TextField } from '@mui/material';
import { FieldLayout } from './FieldLayout';

interface DateFieldProps {
  value: string;
  onChange: (value: string) => void;
  hasErrors?: boolean;
  required?: boolean;
  label: string;
  description?: string;
  videoUrl?: string;
}

export const DateField: React.FC<DateFieldProps> = ({
  value,
  onChange,
  label,
  description,
  hasErrors,
  required,
  videoUrl
}) => {
  const isInvalid = hasErrors && required && !value;
  
  return (
    <FieldLayout 
      label={label}
      description={description}
      videoUrl={videoUrl}
      error={isInvalid}
      helperText={isInvalid ? "Este campo é obrigatório" : undefined}
    >
      <TextField
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        error={isInvalid}
        required={required}
        size="small"
      />
    </FieldLayout>
  );
}; 